import { Button } from "@blofin/blofin-ui";
import { useStoreState } from "../store/useStore";
import { useTranslations } from "use-intl";
import AssetsPopper from "../AssetsPopper";
import OverviewPopper from "../OverviewPopper";

const User = () => {
  const { hideSignUpAndLogIn, isLogin, theme, localeLink } = useStoreState();

  const t = useTranslations("header");

  const getCurrentUrl = (url: string) => {
    const router = window.next?.router;
    const notNextjs = router?.notNextjs;
    if (notNextjs) {
      return `${localeLink}/${url}`;
    }

    if (!router) {
      return "";
    }

    if (router.asPath === "/") {
      return router.basePath !== "/"
        ? `${localeLink}/${url}?redirect=${router.basePath.slice(1)}${localeLink}`
        : `${localeLink}/${url}?redirect=${localeLink.slice(1)}`;
    }

    const refCode =
      router.query?.referral_code &&
      typeof router.query.referral_code === "string" &&
      router.asPath.includes(`?referral_code=`)
        ? `referral_code=${router.query.referral_code}&`
        : "";

    return router.basePath !== "/"
      ? `${localeLink}/${url}?${refCode}redirect=${router.basePath.slice(1)}${localeLink}${router.asPath}`
      : `${localeLink}/${url}?${refCode}redirect=${localeLink.slice(1)}/${router.asPath}`;

    // if (router.basePath !== "/") {
    //   if (router.asPath === "/") {
    //     return `${localeLink}/${url}?redirect=${router.basePath.slice(1)}${localeLink}`;
    //   } else {
    //     return `${localeLink}/${url}?redirect=${router.basePath.slice(1)}${localeLink}${
    //       router.asPath
    //     }`;
    //   }
    // } else {
    //   if (router.asPath === "/") {
    //     return `${localeLink}/${url}?redirect=${localeLink.slice(1)}`;
    //   } else {
    //     return `${localeLink}/${url}?redirect=${localeLink.slice(1)}/${router.asPath}`;
    //   }
    // }
  };

  if (isLogin === null) {
    return null;
  }

  return (
    <div>
      {!isLogin ? (
        hideSignUpAndLogIn ? null : (
          <>
            <a className="max-[600px]:hidden" href={getCurrentUrl("login")}>
              <Button variant="text" size="small" id="header_login_in" theme={theme}>
                {t("login")}
              </Button>
            </a>
            <a href={getCurrentUrl("register")}>
              <Button variant="primary" size="small" id="header_sign_up" theme={theme}>
                {t("signup")}
              </Button>
            </a>
          </>
        )
      ) : (
        <div className="flex">
          <AssetsPopper />
          <OverviewPopper />
        </div>
      )}
    </div>
  );
};

export default User;
